export enum ERouteId {
    CUSTOMERS_ID = 'customers_id',
    ORDERS_ID = 'orders_id',
    PRODUCTS_ID = 'products_id',
    PRODUCTION_LINE_ID = 'production_lines_id'
}
